<template>
  <div class="page-wrapper">
        <header-aotai class="main-header main-header--one clearfix"/>
          <router-view :key="$route.fullPath" id="main"/>
        <footer-aotai class="site-footer" @handleSeek="handleSeek" />
        <seek-dialog v-if="seekShow" :labelTitle="$t('seek.seek_form_Industry')"  @close="handleClose"/>
      </div>
      
</template>
<script>
import HeaderAotai from './header/header.vue'
import FooterAotai from './footer/footer.vue'
import SeekDialog from "@/components/seekDialog.vue"
export default {
  components: {
    HeaderAotai,
    FooterAotai,
    SeekDialog
  },
  data () {
        return {          
            seekShow: false,
        }
    },
  created() {
    console.log('navbar created', this.$route.fullPath)
  },
  
  methods: {
    handleSeek() {
      this.seekShow = true
    },
      // 关闭
      handleClose() {
            this.seekShow = false
        }
  },
  computed: {
  }
}
</script>
<style lang="less">

 .page-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
 
  #main {
    flex: 1;
  }
  .main-header--one {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 500;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 0 60px;
    transition: all 0.36s;
}

.main-header .main-header--one {
  position: fixed;
}
.app-wrapper {
    width: 100%;
    /*min-width: 1200px;*/


    -ms-overflow-style: none; /* IE 10+ */
    // 主体区域
    /*.main-container {*/
    /*    position: relative;*/
    /*    margin-left: 200px;*/
    /*    min-height: 100%;*/
    /*    padding-top: 80px;*/
    /*    background-color: #f1f2f7;*/
    /*}*/
}

// banner图

.page-header {
    overflow: hidden;
    position: relative;
    /* position: relative;
    display: block; */
    padding: 150px 0 150px;
    /* background-color: var(--notech-black); */
    z-index: 1;
}

.page-header__inner {
    text-align: left;
}
 .page-header__inner h1{
    font-size: var(--font-size-30);
    color: var(--notech-white);
    font-weight: 700;
    line-height: 50px;
    margin-bottom: 7px;
 }
 .page-header__inner h3{
    font-size: var(--font-size-20);
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }

 .page-header__breul {
    position: absolute;
    bottom: 20px;
 }

</style>
